<template>
  <v-form v-model="validC" ref="form">
  <v-checkbox append-icon="mdi-help-box" @click:append="commercialHelp=true" v-model="commercialC"
              :label="$t('auth.register.business.checkbox')"/>
  <div v-if="commercial">
    <h4 class="mb-2">{{$t('business')}}</h4>
    <v-text-field :rules="[rules.required]" :variant="variant" :label="$t('auth.register.business.name')" v-model="companyComputed.name"></v-text-field>
    <v-text-field :rules="[rules.required]" :variant="variant" :label="$t('auth.register.business.uStIdNr')" v-model="companyComputed.uStIdNr"></v-text-field>
    <v-select :rules="[rules.required]" :variant="variant" :label="$t('auth.register.business.legalForm')" v-model="companyComputed.legalForm" :items="legalForms">
    </v-select>
    <AddressForm v-model:address="companyComputed.address"/>
  </div>
  <v-dialog scrollable max-height="500px" max-width="400px" v-model="commercialHelp">
    <v-card>
      <v-card-text>
        <h3> {{$t('auth.register.business.hint')}}</h3>
        <br/>
        {{$t('auth.register.business.hintText')}}
        <a target="_blank" href="https://qonto.com/de/blog/business/buchhaltung/umsatzsteuerpflicht">{{$t('readMore')}}.</a>
      </v-card-text>
    </v-card>

  </v-dialog>
  </v-form>
</template>
<script>
import AddressForm from "@/components/auth/AddressForm.vue";

export default {
  name: 'CompanyInfoForm',
  components: {AddressForm},
  data() {
    return {
      rules: {
        required: value => !!value || "Bitte fülle dieses Feld aus"
      },
      commercialHelp: false,
      legalForms:[
        "Einzelunternehmen",
        "Gmbh",
        "AG",
        "KG",
        "OHG",
        "GbR",
        "GmbH_Co_KG",
        "GmbH_Co_OHG"
      ],
    }
  },

  props: {
    valid: {
      type: Boolean,
    },
    variant: {
      type: String,
      default: "outlined"
    },
    commercial: {
      type: Boolean,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  computed:{
    validC:{
      get(){
        return this.valid;
      },
      set(value) {
        this.$emit('update:valid', value);

      }
      },
    commercialC:{
      get(){
        return this.commercial;
      },
      set(value){
        this.$emit('update:commercial', value);
      }
    },
    companyComputed:{
      get(){
        return this.company;
      },
      set(value) {
        this.$emit('update:company', value);
      }
    }
  }
}
</script>